export const TIPOS_CERTIFICACAO = {
    _2BSVS: {
        id: 1,
        nome: '2BSvs'
    },
    PROTERRA: {
        id: 2,
        nome: 'Proterra'
    },
    RTRS: {
        id: 3,
        nome: 'RTRS'
    },
    EPA: {
        id: 4,
        nome: 'EPA'
    }
};
